import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {MatDialogRef} from '@angular/material/dialog';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {AddOrUpdateSpacesOptions} from './options/add-or-update-spaces.options';

@Component({
  selector: 'app-add-or-update-space',
  standalone: false,
  templateUrl: './add-or-update-spaces.component.html',
  styleUrl: './add-or-update-spaces.component.scss'
})
export class AddOrUpdateSpacesComponent extends BaseComponent implements OnInit {
  addOrUpdateSpacesOptions = new AddOrUpdateSpacesOptions();
  title?: any;
  standardCode?: any;
  maxCapacity?: any;
  isActive?: any;
  businessId?: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateSpacesComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateSpacesOptions.space.Title;
    this.standardCode = this.addOrUpdateSpacesOptions.space.StandardCode;
    this.isActive = this.addOrUpdateSpacesOptions.space.IsActive;
    this.maxCapacity = this.addOrUpdateSpacesOptions.space.MaxCapacity;
    this.businessId = this.addOrUpdateSpacesOptions.space.BusinessId;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    (this.addOrUpdateSpacesOptions.space.SpaceId !== undefined ? this.serviceApi.updateSpaces(this.addOrUpdateSpacesOptions.space.SpaceId, {
      Title: this.title,
      StandardCode: this.standardCode,
      Type: 'TABLE',
      MaxCapacity: this.maxCapacity,
      IsActive: this.isActive,
      BusinessId: this.businessId
    }) : this.serviceApi.createSpaces({
      Title: this.title,
      StandardCode: this.standardCode,
      Type: 'TABLE',
      MaxCapacity: this.maxCapacity,
      IsActive: this.isActive,
      BusinessId: this.businessId
    })).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.addOrUpdateSpacesOptions.onInsertOrUpdateFinished();
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
